let sentry = null;

export async function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn || typeof window === 'undefined') return null;
  try {
    const specifier = '@sentry/' + 'react';
    const Sentry = await import(/* @vite-ignore */ specifier);
    Sentry.init({
      dsn,
      environment: process.env.REACT_APP_ENV || 'development',
      tracesSampleRate: 0,
    });
    sentry = Sentry;
    return Sentry;
  } catch {
    return null;
  }
}

export function captureException(error, info) {
  if (sentry?.captureException) {
    sentry.captureException(error, { extra: info });
  }
}
